import React from "react";
import cloneDeep from "lodash/cloneDeep";
import { STANDARD_TABLE } from "../../../../constants/app";

const AvailableSeat = (props) => {
  const {
    availableSeats,
    pageColor,
    dispatchActions,
    user,
    match,
    bookingType,
    onSeatSelect,
  } = props;
  const { userBookingData } = user;
  const {
    seats = null,
    adultCount = 0,
    childCount = 0,
    childAges = [],
    isMultiTable,
    isExtraSeat,
    table,
  } = userBookingData;

  const [errorMessage, setErrorMessage] = React.useState("");

  const isStandardTable = React.useMemo(
    () => bookingType === STANDARD_TABLE,
    [bookingType]
  );

  // React.useEffect(() => {
  //   if (!isMultiTable)
  //     dispatchActions.setUserBookingData({
  //       key: match.params.id,
  //       value: {
  //         ...userBookingData,
  //         table: [],
  //       },
  //     });
  // }, [isMultiTable]);

  // Initialize children ages array when child count changes
  React.useEffect(() => {
    // Adjust the children ages array to match the child count
    if (!isStandardTable) return;

    if (childAges.length < childCount) {
      // Add default ages (0) for new children
      dispatchActions.setUserBookingData({
        key: match.params.id,
        value: {
          ...userBookingData,
          childAges: [
            ...userBookingData.childAges,
            ...Array(childCount - childAges.length).fill(0),
          ],
        },
      });
    } else if (childAges.length > childCount) {
      dispatchActions.setUserBookingData({
        key: match.params.id,
        value: {
          ...userBookingData,
          childAges: userBookingData.childAges.slice(0, childCount),
        },
      });
    }
  }, [childCount]);

  // Validation effect
  React.useEffect(() => {
    if (!isStandardTable) return;
    const totalCount = adultCount + childCount;

    if (seats === 1) {
      // For 1 person, only adult = 1, child = 0 is allowed
      if (adultCount > 1 || childCount > 0) {
        setErrorMessage(
          "大人と子どもの合計人数が選択された人数を超えています。"
        );
      } else {
        setErrorMessage("");
      }
    } else if (totalCount > seats) {
      // Total should not exceed selected count
      setErrorMessage("大人と子どもの合計人数が選択された人数を超えています。");
    } else {
      setErrorMessage("");
    }
  }, [seats, adultCount, childCount]);

  const handleSeatSelect = (count) => {
    // When selecting a new seat count, reset adult/child counts if they exceed the new total
    let data = {
      seats: count,
      table: "",
      chosenTime: "",
      timeDiscount: null,
      totalSeatsTable: 0,
    };
    if (isStandardTable) {
      let newAdultCount = adultCount;
      let newChildCount = childCount;

      if (adultCount + childCount > count || count === 1) {
        // Reset to default values
        newAdultCount = count;
        newChildCount = 0;
      }

      data.adultCount = newAdultCount;
      data.childCount = newChildCount;
    }

    dispatchActions.setUserBookingData({
      key: match.params.id,
      value: {
        ...userBookingData,
        ...data,
      },
    });
    onSeatSelect(count);
  };

  const handleAdultCountChange = (delta) => {
    if (!isStandardTable) return;

    const newCount = Math.max(0, adultCount + delta);
    if (newCount + childCount <= seats) {
      dispatchActions.setUserBookingData({
        key: match.params.id,
        value: {
          ...userBookingData,
          adultCount: newCount,
        },
      });
    }
  };

  const handleChildCountChange = (delta) => {
    if (!isStandardTable) return;

    const newCount = Math.max(0, childCount + delta);
    if (adultCount + newCount <= seats) {
      dispatchActions.setUserBookingData({
        key: match.params.id,
        value: {
          ...userBookingData,
          childCount: newCount,
        },
      });
    }
  };

  const handleChildAgeChange = (index, age) => {
    if (!isStandardTable) return;

    const newAges = [...cloneDeep(childAges)];
    newAges[index] = Number.parseInt(age);
    dispatchActions.setUserBookingData({
      key: match.params.id,
      value: {
        ...userBookingData,
        childAges: newAges,
      },
    });
  };

  const handleChangeMultiTable = React.useCallback(() => {
    if (!isStandardTable) return;

    dispatchActions.setUserBookingData({
      key: match.params.id,
      value: {
        ...userBookingData,
        isMultiTable: !isMultiTable,
        table: isMultiTable ? [] : table,
      },
    });
  }, [isMultiTable, userBookingData]);

  const handleChangeIsExtraSeat = React.useCallback(() => {
    if (!isStandardTable) return;

    dispatchActions.setUserBookingData({
      key: match.params.id,
      value: {
        ...userBookingData,
        isExtraSeat: !isExtraSeat,
      },
    });
  }, [isExtraSeat, userBookingData]);

  return (
    <div className="px-3 mt-3">
      {/* Header with count indicator */}
      <div className="d-flex align-items-center mb-3">
        <span className="text-dark fw-bold">人数</span>
      </div>

      {/* Scrollable seat options */}
      <div
        className="mb-2 w-100"
        style={{
          minHeight: "1px",
        }}
      >
        <div
          className="d-flex gap-2 pb-2 flex-wrap"
          style={{
            WebkitOverflowScrolling: "touch",
            minHeight: "1px",
          }}
        >
          {availableSeats.map((count) => {
            const isSelected = seats === count;
            return (
              <button
                key={count}
                onClick={() => handleSeatSelect(count)}
                className={`btn btn-sm px-2 py-2 border ${
                  isSelected ? "text-white border-0" : "btn-outline-secondary"
                }`}
                style={{
                  backgroundColor: isSelected ? pageColor : undefined,
                  minWidth: "60px",
                }}
              >
                <div className="d-flex">
                  <div
                    className="me-2"
                    style={{
                      border: `1px solid ${isSelected ? "white" : pageColor}`,
                      width: "15px",
                      height: "15px",
                      borderRadius: "100%",
                      flex: "none",
                    }}
                  />
                  {count}名
                </div>
              </button>
            );
          })}
        </div>
      </div>
      {bookingType === STANDARD_TABLE && seats && (
        <div className="booking-options-seats text-left d-flex">
          <div
            className="btn py-2 d-flex align-items-center"
            style={{
              border: "1px solid",
              borderColor: isMultiTable ? pageColor : "#ddd",
              color: isMultiTable ? pageColor : "",
            }}
            onClick={handleChangeMultiTable}
          >
            <input
              type="checkbox"
              checked={isMultiTable}
              style={{
                accentColor: pageColor,
              }}
              onChange={() => {}}
            />
            <span
              className="ps-2"
              style={{
                fontSize: 12,
              }}
            >
              複数のテーブルに分かれてもよい
            </span>
          </div>
          <div
            className="btn py-2 d-flex align-items-center ms-3"
            style={{
              border: "1px solid",
              borderColor: isExtraSeat ? pageColor : "#ddd",
              color: isExtraSeat ? pageColor : "",
            }}
            onClick={handleChangeIsExtraSeat}
          >
            <input
              type="checkbox"
              checked={isExtraSeat}
              style={{
                accentColor: pageColor,
              }}
              onChange={() => {}}
            />
            <span
              className="ps-2"
              style={{
                fontSize: 12,
              }}
            >
              補助イスの利用を許可する
            </span>
          </div>
        </div>
      )}

      {isStandardTable && (
        <div className="mt-2">
          {/* Adult count */}
          <div className="d-flex align-items-center mb-3">
            <div className="d-flex align-items-center me-3">
              <span className="text-dark fw-medium fw-bold">大人: </span>
            </div>
            <div className="d-flex align-items-center flex-grow-1 gap-3 justify-content-between">
              <span className="text-dark fw-bold">{Number(adultCount)} 人</span>
              <div className="btn-group">
                <button
                  onClick={() => handleAdultCountChange(-1)}
                  disabled={adultCount <= 0}
                  className="btn btn-outline-secondary"
                  style={{ width: "40px", height: "40px" }}
                >
                  −
                </button>
                <button
                  onClick={() => handleAdultCountChange(1)}
                  disabled={adultCount + childCount >= seats}
                  className="btn btn-outline-secondary"
                  style={{ width: "40px", height: "40px" }}
                >
                  +
                </button>
              </div>
            </div>
          </div>

          {/* Child count */}
          <div className="d-flex align-items-center mb-3">
            <div className="d-flex align-items-center me-3">
              <span className="text-dark fw-medium fw-bold">子供: </span>
            </div>
            <div className="d-flex align-items-center gap-3 flex-grow-1 justify-content-between">
              <span className="text-dark fw-bold">{Number(childCount)} 人</span>
              <div className="btn-group">
                <button
                  onClick={() => handleChildCountChange(-1)}
                  disabled={childCount <= 0}
                  className="btn btn-outline-secondary"
                  style={{ width: "40px", height: "40px" }}
                >
                  −
                </button>
                <button
                  onClick={() => handleChildCountChange(1)}
                  disabled={adultCount + childCount >= seats || seats === 1}
                  className="btn btn-outline-secondary"
                  style={{ width: "40px", height: "40px" }}
                >
                  +
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Children Age Selection (4.2) */}
      {isStandardTable && childCount > 0 && (
        <div className="mt-4">
          <div className="d-flex align-items-center mb-3">
            <span className="text-dark fw-bold me-2">子供の年齢</span>
          </div>

          <div>
            {Array.from({ length: childCount }).map((_, index) => (
              <div key={index} className="d-flex align-items-center mb-3">
                <div style={{ width: "100px" }}>
                  <span className="text-dark fw-medium">{index + 1}人目</span>
                </div>
                <div className="d-flex align-items-center">
                  <select
                    value={childAges[index] || 0}
                    onChange={(e) =>
                      handleChildAgeChange(index, e.target.value)
                    }
                    className="form-select me-2"
                    style={{ width: "80px" }}
                  >
                    {Array.from({ length: 19 }).map((_, age) => (
                      <option key={age} value={age}>
                        {age}
                      </option>
                    ))}
                  </select>
                  <span className="text-dark">歳</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Error message */}
      {errorMessage && (
        <div className="mt-3 text-danger small">{errorMessage}</div>
      )}
    </div>
  );
};

export default React.memo(AvailableSeat);
